<script setup>
import { ref } from 'vue';
import BreezeButton from '@/Components/Button.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
// - LRR import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeGuestLayout from '@/Layouts/GuestUnens.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
defineProps({
    canResetPassword: Boolean,
    status: String,
});

const showPassword = ref(false);

const form = useForm({
    email: '',
    password: '',
    remember: false
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};
</script>

<template>
    <div class="bg-no-repeat bg-cover lg:min-h-screen" style="background-image: url(/img/login/bg.png);">
        <div class="min-h-screen flex my-auto"><!-- FIX background -->
            <div class="max-w-6xl relative z-10 m-auto">
                <div class="grid md:grid-cols-1 lg:grid-cols-5 gap-5 items-center ">
                    <BreezeGuestLayout class="col-span-3 shadow-lg">
                
                        <Head title="Log in" />

                        <div class="sm:w-full text-left m-auto lg:m-0">
                            <h1 class="text-2xl md:text-3xl 2xl:text-4xl font-bold mb-3">Ingresa a tu cuenta.</h1>
                        </div>

                        <BreezeValidationErrors class="mb-4" />
                        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                            {{ status }}
                        </div>
                        <form @submit.prevent="submit">
                            <div>
                                <label for="email" value="Usuario / Email" class="block text-sm">Usuario / Email</label>
                                <input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
                            </div>
                            <div class="mt-4">
                                <label for="password" value="Password" class="block text-sm">Password</label>
                                <div class="relative mt-1">
                                    <input id="password" :type="showPassword ? 'text' : 'password'" class="block w-full pr-10" v-model="form.password" required autocomplete="current-password" />
                                    <button type="button" @click="showPassword = !showPassword" class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-gray-700 focus:outline-none" :title="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                                        <!-- Ojo abierto -->
                                        <i v-if="!showPassword" class="fa-regular fa-eye text-gray-700"></i>
                                        <!-- Ojo tachado -->
                                        <i v-else class="fa-regular fa-eye-slash text-gray-700"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="block mt-4">
                                <label class="flex items-center">
                                    <BreezeCheckbox name="remember" v-model:checked="form.remember" />
                                    <span class="ml-2 text-sm text-gray-600">Recuerdame</span>
                                </label>
                            </div>
                            <div class="flex items-center justify-end mt-4">
                                <Link v-if="canResetPassword" :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                    Olvidaste tu password?
                                </Link>
                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Ingresar
                                </BreezeButton>
                            </div>
                        </form>
                        
                    </BreezeGuestLayout>
                    <div class="pt-10 lg:pt-0 hidden lg:block lg:col-span-2 h-full rounded-lg  shadow-lg">
                        <!-- <div class="w-full rounded-lg bg-div" style="min-height:524px; min-width: 390px; background: url(/img/login/lat.jpg);">
                        </div> -->

                        

                        <Splide :options="{ rewind: true, perMove: 1, type: 'loop', autoplay: true, pagination: boolean = false, arrows: boolean = false, gap: '1em', mediaQuery: 'min', breakpoints: { 0: { perPage: 1 } } }" class="rounded-lg h-full splide-h-full ">
                            <div class="splide__arrows"></div>
                            <SplideSlide class="rounded-lg h-full ">
                                <div class="bg-[url('/img/login/slider-01.jpg')] bg-no-repeat bg-center bg-cover rounded-lg h-full border border-gray-300">
                                    <div class="rounded-lg h-full"><!-- Transparencia Wallpaper -+ bg-black/30-->
                                        <!-- <div class="text-white p-6 bottom-0 flex items-end h-full">
                                            <p class="text-2xl font-bold ">Gestión Educativa</p>
                                        </div> -->
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide class="rounded-lg h-full">
                                <div class="bg-[url('/img/login/slider-02.jpg')] bg-no-repeat bg-center bg-cover rounded-lg h-full border border-gray-300">
                                    <div class="rounded-lg h-full"><!-- Transparencia Wallpaper -+ bg-black/30-->
                                        <!-- <div class="text-white p-6 bottom-0 flex items-end h-full">
                                            <p class="text-2xl font-bold ">Gestión Educativa</p>
                                        </div> -->
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide class="rounded-lg h-full">
                                <div class="bg-[url('/img/login/slider-03.jpg')] bg-no-repeat bg-center bg-cover rounded-lg h-full border border-gray-300">
                                    <div class="rounded-lg h-full"><!-- Transparencia Wallpaper -+ bg-black/30-->
                                        <!-- <div class="text-white p-6 bottom-0 flex items-end h-full">
                                            <p class="text-2xl font-bold ">Gestión Educativa</p>
                                        </div> -->
                                    </div>
                                </div>
                            </SplideSlide>

                        </Splide>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
